import { takeLatest } from 'redux-saga/effects';
import { genericFlowActions } from './genericFlowSlice';
import callFetchMaterialToSelectSaga from './sagas/callFetchMaterialsToSelectSaga';
import callGetExistingSelectionSaga from './sagas/callGetExistingSelectionSaga';

export default function* genericFlowSaga() {
  yield takeLatest(genericFlowActions.getMaterialsToSelect, callFetchMaterialToSelectSaga);
  yield takeLatest(genericFlowActions.getExistingSelection, callGetExistingSelectionSaga);
}
